import script from "./ProductQuality.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductQuality.vue?vue&type=script&setup=true&lang=js"

import "./ProductQuality.vue?vue&type=style&index=0&id=647f85f4&lang=scss"

const __exports__ = script;

export default __exports__